// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1MHj_","title":"ClientReferral_title__2TTQE","itemText":"ClientReferral_itemText__3Il3Y"};